import React from 'react';
import type { RouteObject } from 'react-router-dom';
import RequireRole from '../../shared/guards/RequireRole';
import InventoryWorkspace from './InventoryWorkspace';
import ItemList from './ItemList';
import ItemDetail from './ItemDetail';
import ItemForm from './ItemForm';
import Receiving from './Receiving';
import ReceivingForm from './ReceivingForm';
import ReceivingDetail from './ReceivingDetail';
import Suppliers from './Suppliers';
import SupplierDetail from './SupplierDetail';
import Categories from './Categories';
import ImportInventory from './ImportInventory';
import InvoiceScan from './InvoiceScan';
import StockLedger from './StockLedger';
import ParSuggestions from './ParSuggestions';

const g = (el: React.ReactElement) => <RequireRole allowedRoles={['Owner', 'Admin', 'Manager']}>{el}</RequireRole>;

export const inventoryV2Routes: RouteObject[] = [
  { path: 'inventory', element: g(<InventoryWorkspace />) },
  { path: 'inventory/items', element: g(<ItemList />) },
  { path: 'inventory/items/new', element: g(<ItemForm />) },
  { path: 'inventory/items/:id', element: g(<ItemDetail />) },
  { path: 'inventory/items/:id/edit', element: g(<ItemForm />) },
  { path: 'inventory/receiving', element: g(<Receiving />) },
  { path: 'inventory/receiving/new', element: g(<ReceivingForm />) },
  { path: 'inventory/receiving/:id', element: g(<ReceivingDetail />) },
  { path: 'inventory/receiving/:id/edit', element: g(<ReceivingForm />) },
  { path: 'inventory/suppliers', element: g(<Suppliers />) },
  { path: 'inventory/suppliers/:id', element: g(<SupplierDetail />) },
  { path: 'inventory/categories', element: g(<Categories />) },
  { path: 'inventory/import', element: g(<ImportInventory />) },
  { path: 'inventory/invoice-scan', element: g(<InvoiceScan />) },
  { path: 'inventory/ledger', element: g(<StockLedger />) },
  { path: 'inventory/par-suggestions', element: g(<ParSuggestions />) },
];
